import { useState } from "react";
import { enviarMensaje, enlaceWhatsApp } from "../lib/envios";
import { firebaseListo } from "../lib/firebase";
import { EMPRESA, esPendiente } from "../lib/config";
import p from "./Pagina.module.css";

const VACIO = { nombre: "", email: "", telefono: "", asunto: "", mensaje: "" };

export default function Contacto() {
  const [datos, setDatos] = useState(VACIO);
  const [estado, setEstado] = useState("inicial"); // inicial | enviando | ok | error

  function actualizar(campo, valor) {
    setDatos((d) => ({ ...d, [campo]: valor }));
  }

  async function alEnviar(e) {
    e.preventDefault();
    setEstado("enviando");
    try {
      await enviarMensaje(datos);
      setDatos(VACIO);
      setEstado("ok");
    } catch (err) {
      console.error(err);
      setEstado("error");
    }
  }

  return (
    <>
      <header className={p.cabecera}>
        <div className="container">
          <p className="eyebrow">Contacto</p>
          <h1 className={p.titulo}>Hablemos de tu proyecto</h1>
          <p className={p.subtitulo}>
            Escribenos y te respondemos dentro del siguiente dia habil. Si es
            urgente, el WhatsApp es la via mas rapida.
          </p>
        </div>
      </header>

      <section className={`container ${p.cuerpo}`}>
        <div className={p.dosColumnas}>
          <form className={p.formulario} onSubmit={alEnviar}>
            <div className={p.filaCampos}>
              <div className="field">
                <label className="label" htmlFor="ct-nombre">
                  Nombre *
                </label>
                <input
                  id="ct-nombre"
                  className="input"
                  required
                  value={datos.nombre}
                  onChange={(e) => actualizar("nombre", e.target.value)}
                />
              </div>

              <div className="field">
                <label className="label" htmlFor="ct-telefono">
                  Telefono
                </label>
                <input
                  id="ct-telefono"
                  className="input"
                  type="tel"
                  value={datos.telefono}
                  onChange={(e) => actualizar("telefono", e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label className="label" htmlFor="ct-email">
                Correo *
              </label>
              <input
                id="ct-email"
                className="input"
                type="email"
                required
                value={datos.email}
                onChange={(e) => actualizar("email", e.target.value)}
              />
            </div>

            <div className="field">
              <label className="label" htmlFor="ct-asunto">
                Asunto
              </label>
              <input
                id="ct-asunto"
                className="input"
                placeholder="Cotizacion, disponibilidad, despacho..."
                value={datos.asunto}
                onChange={(e) => actualizar("asunto", e.target.value)}
              />
            </div>

            <div className="field">
              <label className="label" htmlFor="ct-mensaje">
                Mensaje *
              </label>
              <textarea
                id="ct-mensaje"
                className="textarea"
                required
                value={datos.mensaje}
                onChange={(e) => actualizar("mensaje", e.target.value)}
              />
            </div>

            {estado === "ok" && (
              <p className={p.exito}>
                Mensaje enviado. Te respondemos al correo que registraste.
                {!firebaseListo &&
                  " (Nota: el backend aun no esta conectado, asi que este mensaje no quedo guardado.)"}
              </p>
            )}

            {estado === "error" && (
              <p className={p.error}>
                No pudimos enviar el mensaje. Intenta de nuevo o escribenos por
                WhatsApp.
              </p>
            )}

            <button
              type="submit"
              className="btn btn--accent"
              disabled={estado === "enviando"}
            >
              {estado === "enviando" ? "Enviando..." : "Enviar mensaje"}
            </button>
          </form>

          <div className={p.datos}>
            <div className={p.datoBloque}>
              <span className={p.datoTitulo}>WhatsApp</span>
              <span className={p.datoValor}>
                <a
                  href={enlaceWhatsApp(
                    `Hola ${EMPRESA.nombre}, quiero consultar por un material.`
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Escribir ahora
                </a>
              </span>
            </div>

            <div className={p.datoBloque}>
              <span className={p.datoTitulo}>Correo</span>
              <span className={p.datoValor}>
                <a href={`mailto:${EMPRESA.email}`}>{EMPRESA.email}</a>
              </span>
            </div>

            {!esPendiente(EMPRESA.telefono) && (
              <div className={p.datoBloque}>
                <span className={p.datoTitulo}>Telefono</span>
                <span className={`${p.datoValor} mono`}>{EMPRESA.telefono}</span>
              </div>
            )}

            <div className={p.datoBloque}>
              <span className={p.datoTitulo}>Direccion</span>
              <span className={p.datoValor}>
                {!esPendiente(EMPRESA.direccion) && (
                  <>
                    {EMPRESA.direccion}
                    <br />
                  </>
                )}
                {EMPRESA.ciudad}
              </span>
            </div>

            <div className={p.datoBloque}>
              <span className={p.datoTitulo}>Horario</span>
              <span className={p.datoValor}>{EMPRESA.horario}</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
